import * as React from "react";
import { LocalizeContextProps, withLocalize } from "react-localize-redux";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { Col, Row } from "reactstrap";
import { Dispatch } from "redux";
import DefaultRedirect from "../../../routing/DefaultRedirect";
import {
  isLoggedIn,
  ssoEnabled,
  url,
  task,
} from "../../../stores/auth/selectors";
import { RootState } from "../../../stores/store";
import CenterContainer from "../../layout/CenterContainer";
import Logo from "./Logo";
import LoginDialog from "./LoginDialog";
import LoadingScreen from "../../navigation/LoadingScreen";

export interface Props extends RouteComponentProps, LocalizeContextProps {
  isLoggedIn: boolean;
  ssoEnabled: boolean;
  url: string;
  task: string;
}

export class LoginPage extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  public render() {
    const t = this.props.translate;
    if (!this.props.isLoggedIn) {
      if (this.props.ssoEnabled) {
        return <LoadingScreen text={t("loading.loading") as string} />;
      }
      return (
        <div className="login-container">
          <Row className="m-0">
            <Col sm={3}>
              <Logo />
            </Col>

            <Col sm={9}>
              <LoginDialog />
            </Col>
          </Row>
        </div>
      );
    } else {
      return <DefaultRedirect />;
    }
  }
}

const mapStateToProps = (state: RootState) => ({
  isLoggedIn: isLoggedIn(state),
  ssoEnabled: ssoEnabled(state),
  url: url(state),
  task: task(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withLocalize(withRouter(LoginPage)));
